import React from 'react';

const UrlList = ({ urls }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        alert('URL copied to clipboard!');
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
      });
  };

  if (!urls || urls.length === 0) {
    return (
      <div className="card">
        <p>No shortened URLs yet. Create one above!</p>
      </div>
    );
  }

  return (
    <div className="card url-list">
      <h2>Your Shortened URLs</h2>
      {urls.map(url => {
        const shortUrl = `https://surl.yz87.org/${url.short_code}`;
        return (
          <div key={url.id} className="url-item">
            <div>
              <div>
                <strong>Original:</strong> {url.original_url.length > 50 
                  ? `${url.original_url.substring(0, 50)}...` 
                  : url.original_url}
              </div>
              <div>
                <strong>Short URL:</strong> 
                <a href={shortUrl} target="_blank" rel="noopener noreferrer" className="short-url">
                  {shortUrl}
                </a>
                <button 
                  className="copy-button" 
                  onClick={() => copyToClipboard(shortUrl)}
                >
                  Copy
                </button>
              </div>
              <div className="stats">
                <span>Created: {new Date(url.created_at).toLocaleDateString()}</span> | 
                <span> Visits: {url.visits}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UrlList;
